import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  UPLOAD_UTILITY_ATTACHMENT,
  UPLOAD_UTILITY_ATTACHMENT_SUCCESS,
  UPLOAD_UTILITY_ATTACHMENT_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* uploadUtilityAttachment({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const formData = new FormData();
    formData.append('utility-request-attachments', payload.file);

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/attachments`,
      method: 'POST',
      data: formData,
      isFormData: true,
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      cogoToast.success('Attachment uploaded successfully');
      yield put({
        type: UPLOAD_UTILITY_ATTACHMENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Upload failed');
      yield put({ type: UPLOAD_UTILITY_ATTACHMENT_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Upload failed');
    yield put({ type: UPLOAD_UTILITY_ATTACHMENT_ERROR, payload: error });
  }
}

export function* watchUploadUtilityAttachment() {
  yield takeEvery(UPLOAD_UTILITY_ATTACHMENT, uploadUtilityAttachment);
}

function* uploadUtilityAttachmentSaga() {
  yield all([fork(watchUploadUtilityAttachment)]);
}

export default uploadUtilityAttachmentSaga;
